/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import BrokeragePricing from "./BrokeragePricing.container";

export default BrokeragePricing;
